<template>
  <div class="riskList">
    <div class="table-box">
      <div class="title flex justify-between align-center">
        <div class="flex justify-start align-center" >
          <div class="icon-box">
            <i class="iconfont icon-xiazai3"></i>
          </div>
          <b>下载中心</b>
        </div>
<!--        <div class="page-cancel" @click="$router.go(-1)">-->
<!--          <i class="icon iconfont icon-jiantouzuo1"></i>返回-->
<!--        </div>-->
      </div>
      <div class="list padding-top">
        <el-table
          border
          :data="tableData"
          :header-cell-style="centerbgc"
          :cell-style="textCenter"
          style="width: 100%">
          <el-table-column
            label="序号"
            type="index"
            width="80">
          </el-table-column>
          <el-table-column
            prop="title"
            width="350"
            label="标题">
          </el-table-column>
          <el-table-column
            prop="desc"
            label="描述">
          </el-table-column>
          <el-table-column
            width="250"
            prop="publish_time"
            label="时间">
          </el-table-column>
          <el-table-column
            label="操作"
            width="200">
            <template slot-scope="scope" class="flex">
              <div class="edit" @click="dowmload(scope.row)">下载</div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="page-box">
        <el-pagination
          :current-page.sync="search.page"
          :page-size="search.limit"
          :total="search.total"
          background
          class="page-all margin-top self-end"
          layout="prev, pager, next"
          @current-change="list">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import {isYes} from "@/utils/const";
import {org_article_detail, org_indexlst} from "@/api";
import {
  frontDownload
} from "@/utils/utils";
export default {
  name: "publicizeList",
  data() {
    return {
      isYes:isYes,
      dialogVisible: false,
      type: 4,
      search:{
        keyword:'',
        page:1,
        limit:10,
        total:0,
      },
      tableData:[]
    }
  },
  components: {},
  computed: {
    textCenter(){
      return {
        textAlign: 'center'
      }
    },
    centerbgc(){
      return {
        textAlign: 'center',
        background: '#f7f7f7'
      }
    }
  },
  created() {
    this.$emit("setActive", {
      headActive: 6
    })
    this.list()
  },
  methods: {
    async list() {
      let _data = await org_indexlst(
        this.search.keyword,
        this.search.page,
        this.search.limit,
        this.type
      );
      if (_data.status == 200) {
        this.tableData = _data.data.data;
        this.search.total = _data.data.total;
      }
    },

    async dowmload(row){
      let _data = await org_article_detail(row.id);
      if (_data.status == 200) {
       frontDownload(_data.data.files)
      }
    },

    searchFun() {
      this.search.page = 1
      this.tableData = []
      this.list()
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.riskList {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - (173px + 159px));
  background: #f3f5f7;
  padding: 20px;
  .edit {
    display: inline-block;
    margin: 0 15px;
    color: #0089ff;
    cursor: pointer;
  }
  .del {
    display: inline-block;
    margin: 0 15px;
    color: #f74945;
    cursor: pointer;
  }
  .table-box {
    width: 100%;
    background-image: linear-gradient(0deg,
      #ffffff 84%,
      #edf6ff 100%);
    padding: 0 20px;
    border-radius: 10px;
    min-height: 500px;
    .text-ellipsis {
      color: #666666;
      text-align: center;
      &.active {
        color: #f74945;
      }
    }
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 60px;
      border-bottom: 2px solid #e3e7f0;
      b {
        font-size: 22px;
        color: #16181d;
        font-weight: bold;
        margin-left: 10px;
      }
      .icon-box {
        width: 30px;
        height: 30px;
        background-image: linear-gradient(-30deg,
          #3579fb 0%,
          #44a3ff 100%);
        box-shadow: 0px 10px 10px 0px
        rgba(50, 150, 255, 0.3);
        border-radius: 10px;
        text-align: center;
        line-height: 30px;

        i {
          font-size: 20px;
          color: #ffffff;
        }
      }
    }
    .list {
      width: 100%;
      .btn {
        width: 60px;
        height: 26px;
        border-radius: 4px;
        font-size: 14px;
        text-align: center;
        line-height: 26px;
        margin: 0 auto;
        &.gray {
          color: #8a8a8a;
          background-color: #f2f2f2;
        }
        &.yellow {
          color: #fad471;
          background-color: #fffbdd;
        }
        &.orange {
          color: #f58739;
          background-color: #ffeedd;
        }
        &.red {
          color: #f8001a;
          background-color: #ffdddd;
        }
      }
    }
    .search-flex {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      padding: 20px 0;
      .shensu {
        width: 153px;
        height: 37px;
        background-image: linear-gradient(0deg,
          #f59a23 0%,
          #feb555 100%);
        border-radius: 4px;
        text-align: center;
        line-height: 37px;
        font-size: 16px;
        color: #ffffff;
        cursor: pointer;
        i {
          font-size: 20px;
          margin-right: 5px;
          color: #ffffff;
        }
      }
      .search-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .search-btn {
          width: 112px;
          height: 36px;
          background-image: linear-gradient(0deg,
            #2791ff 0%,
            #81b6ff 100%);
          border-radius: 4px;
          text-align: center;
          line-height: 36px;
          font-size: 16px;
          color: #ffffff;
          margin-left: 15px;
          cursor: pointer;
          i {
            font-size: 20px;
            margin-right: 5px;
            color: #ffffff;
          }
          &.reset {
            background-image:none;
            background-color: #ffffff;
            border-radius: 4px;
            border: solid 1px #cccccc;
            line-height: 34px;
            color: #333333;
            i {
              color: #999999;
            }
          }
        }
      }

    }
  }

}
</style>


